"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var S_Saves = {
    STORAGE_KEY_PREFIX: 'default_storage_key_prefix',
    isLogDebug: process.env.NODE_ENV !== 'production',
    setStorageKeyPrefix: function (value) {
        S_Saves.STORAGE_KEY_PREFIX = value;
    },
    // stockage
    checkLocalStorageSize: function (cb) {
        if (window.localStorage && !window.localStorage.getItem('size')) {
            var i = 0;
            try {
                // Test up to 10 MB
                for (i = 250; i <= 10000; i += 250) {
                    localStorage.setItem('test', new Array((i * 1024) + 1).join('a'));
                }
            }
            catch (e) {
                var approximateSize = i - 250;
                localStorage.removeItem('test');
                localStorage.setItem('size', approximateSize + '');
                if (S_Saves.isLogDebug)
                    console.log('Size of localStorage :', approximateSize, 'Kb');
            }
        }
        if (cb)
            cb();
    },
    readLocalStorageSizeEffective: function (arrayOfItems, cb) {
        var total = 0;
        if (window.localStorage) {
            for (var i = 0; i < arrayOfItems.length; i++) {
                if (!window.localStorage.getItem(S_Saves.STORAGE_KEY_PREFIX + '_' + arrayOfItems[i]))
                    continue;
                var value = window.localStorage[S_Saves.STORAGE_KEY_PREFIX + '_' + arrayOfItems[i]];
                var valueKb = encodeURI(value).split(/%..|./).length - 1;
                total += valueKb;
            }
            if (S_Saves.isLogDebug)
                console.log('Size of datas :', total, 'b');
        }
        if (cb)
            cb(total);
    },
    // renvoie en Kb la taille max de stockage possible
    readLocalStorageSize: function (cb) {
        var size = window.localStorage['size'];
        if (S_Saves.isLogDebug)
            console.log('-- S_Saves.tsx -- readLocalStorageSize() size', size);
        if (cb)
            cb(size);
    },
    getLocalStorageDatasStringified: function (arrayOfItems, cb) {
        var all = '';
        if (window.localStorage) {
            for (var i = 0; i < arrayOfItems.length; i++) {
                var KEY = S_Saves.STORAGE_KEY_PREFIX + '_' + arrayOfItems[i];
                if (!window.localStorage.getItem(KEY))
                    continue;
                var value = window.localStorage[KEY];
                all = all + (all === '' ? '' : '\n') + KEY + '=' + value;
            }
            if (S_Saves.isLogDebug)
                console.log('All datas :', all);
        }
        if (cb)
            cb(all);
    }
};
exports.default = S_Saves;
//# sourceMappingURL=S_Saves.js.map